import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("CorteIngresosZE");
const crud = rpcCrudService<models.CorteIngresosZE, models.CorteIngresosZEDto>(controller);

const otros = {

    /**
 * Genera el corte del día según el usuario y la sucursal que lo llama
 * @param idSucursal 
 * @param idUsuario 
 */
    GenerarCorte: async (): Promise<number> => await controller("GenerarCorte", {}),
}

export const CorteIngresosZE = cacheResource({
    ...crud,
    ...otros
}, {

    }, {
        GenerarCorte: true
    })


// WEBPACK FOOTER //
// ./app/resources/items/corteingresosze.tsx